// src/utils/draftTaller.ts
//
// Persistencia de borradores de "Crear Evento" en Firestore.
// Colección: `taller_borrador` (separada de `taller` para no contaminar producción).
// Cada usuario tiene a lo sumo 1 borrador → doc id = uid.

import {
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  collection,
  getDocs,
  Timestamp
} from 'firebase/firestore';
import { db } from '../firebaseConfig';

export interface DraftTallerUI {
  tipoCosto: string;
  requiereRegistro: boolean;
  tipoEvento: string;
  ponentes: any[];
  patrocinadores: any[];
  agenda: any[];
  actividades: string[];
}

export interface DraftTallerDoc {
  user_uid: string;
  user_nombre: string;
  user_correo: string;
  nombre_evento: string;
  formValues: any;
  ui: DraftTallerUI;
  savedAt: Timestamp;
  savedAtMillis: number;
}

const COLLECTION = 'taller_borrador';

export const guardarBorradorFirestore = async (
  uid: string,
  data: {
    user_nombre: string;
    user_correo: string;
    formValues: any;
    ui: DraftTallerUI;
  }
): Promise<void> => {
  if (!uid) return;
  const ahora = Timestamp.now();
  const payload: DraftTallerDoc = {
    user_uid: uid,
    user_nombre: data.user_nombre || '',
    user_correo: data.user_correo || '',
    nombre_evento: data.formValues?.nombre || '(sin nombre)',
    formValues: data.formValues || {},
    ui: data.ui,
    savedAt: ahora,
    savedAtMillis: ahora.toMillis()
  };
  await setDoc(doc(db, COLLECTION, uid), payload);
};

export const cargarBorradorFirestore = async (uid: string): Promise<DraftTallerDoc | null> => {
  if (!uid) return null;
  const snap = await getDoc(doc(db, COLLECTION, uid));
  if (!snap.exists()) return null;
  return snap.data() as DraftTallerDoc;
};

export const eliminarBorradorFirestore = async (uid: string): Promise<void> => {
  if (!uid) return;
  try {
    await deleteDoc(doc(db, COLLECTION, uid));
  } catch {
    // noop — el borrador puede no existir
  }
};

export const listarBorradoresFirestore = async (): Promise<DraftTallerDoc[]> => {
  const snap = await getDocs(collection(db, COLLECTION));
  return snap.docs.map(d => d.data() as DraftTallerDoc);
};
